// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__37WSV","title":"BackImages_title__16SS-","images":"BackImages_images__2gcEe"};